// extracted by mini-css-extract-plugin
export default {"container":"JumpToSkeletonLoader__container___ZhpRZ","columns":"JumpToSkeletonLoader__columns___aq_Cm"};